import { c as _c } from "react/compiler-runtime";
import { ModuleIcon } from '#components/Icon/ModuleIcon';
import { useCurrentDate } from '#cutils/context/TimeContext';
import { IconSystem } from '#icons/IconSystem';
import { formatTimestamp } from '#utils/time/formatTimestamp';
import { Link } from '../Link/Link';
import type { HeadlineItem } from './Headlines.utils';
import styles from './HeadlinesArticle.module.scss';
type Props = Omit<HeadlineItem, 'id'>;
export function HeadlinesArticle(t0) {
  const $ = _c(10);
  const {
    icon,
    path,
    title,
    date
  } = t0;
  const currentDate = useCurrentDate();
  let t1;
  if ($[0] !== currentDate || $[1] !== date) {
    t1 = date ? formatTimestamp(date, currentDate) : "";
    $[0] = currentDate;
    $[1] = date;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== icon) {
    t2 = icon === "BREAKING_NEWS" ? <IconSystem className={styles.icon} icon="flash" variant="filled" title="Breaking News Artikel" /> : <ModuleIcon className={styles.icon} moduleType={icon} />;
    $[3] = icon;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== path || $[6] !== t1 || $[7] !== t2 || $[8] !== title) {
    t3 = <li className={styles.listItem}><Link className={styles.linkWithIcon} href={path} title={t1}>{t2}{title}</Link></li>;
    $[5] = path;
    $[6] = t1;
    $[7] = t2;
    $[8] = title;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}